import React from 'react';

/* ────────────────────────────────────────────────────────────────────────────
   AmbientBackground — mini-spec #14 (Layer 2)

   App-wide animated atmospheric layer that sits behind every authed
   route, dashboard, chat surface and modal. Pure CSS — no canvas, no
   WebGL, no images. Five radial-gradient "orbs" drift, scale and
   hue-shift on independent timings so they never sync, blended via
   mix-blend-mode: screen onto a #04050A void base.

   Mounted ONCE at the App root so animations persist across route
   changes. The 15% global opacity ceiling keeps it ambient — never
   pulling focus from foreground content. `prefers-reduced-motion` is
   honored at the CSS layer (animations pause).
   ──────────────────────────────────────────────────────────────────────── */

export default function AmbientBackground() {
  return (
    <div className="ambient-bg" aria-hidden="true">
      <div className="ambient-bg-stack">
        <span className="ambient-orb ambient-orb-1" />
        <span className="ambient-orb ambient-orb-2" />
        <span className="ambient-orb ambient-orb-3" />
        <span className="ambient-orb ambient-orb-4" />
        <span className="ambient-orb ambient-orb-5" />
      </div>
    </div>
  );
}
